import { render } from "./CommonLayouts.vue?vue&type=template&id=bf75e1f8&scoped=true&ts=true"
import script from "./CommonLayouts.vue?vue&type=script&lang=ts"
export * from "./CommonLayouts.vue?vue&type=script&lang=ts"

import "./CommonLayouts.vue?vue&type=style&index=0&id=bf75e1f8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf75e1f8"]])

export default __exports__